import React from "react";

function SearchPopup() {
  return (
    <div className="search-popup">
      <button className="close-search">
        <span className="far fa-times"></span>
      </button>

      <form action="#">
        <div className="form-group">
          <input
            type="search"
            name="search-field"
            className="form-control"
            placeholder="Search Here..."
            required
          />
          <button type="submit">
            <i className="far fa-search"></i>
          </button>
        </div>
      </form>
    </div>
  );
}

export default SearchPopup;
